<template>
	
	 <article>
	  <figure class="img img-landscape">
		 <router-link :to="article.type === 'post' ? '/news/' + article.uid : '/magazine/' + article.uid">
			 <prismic-image :field="article.data.featured_image"/><figcaption><prismic-rich-text :field="article.data.featured_image_caption"/></figcaption>
		 </router-link>
	  </figure>
	    <aside class="wrap wrap-half">
	        <div class="bt text-larger">
		          <span v-if="article.tags.includes('reports')" class="text-uppercase text-condensed">Performa Reports</span>
				      <span v-if="article.tags.includes('in-conversation')" class="text-uppercase text-condensed">In Conversation</span>
				      <span v-if="article.tags.includes('features')" class="text-uppercase text-condensed">Features</span>
				      <span v-if="article.tags.includes('essays')" class="text-uppercase text-condensed">Essays</span>
	            <h4 class="text-extended text-larger"><strong>{{ article.data.title }}</strong></h4><br/>
	            <span class="date text-uppercase text-condensed text-underline">{{ labelFormat(article.data.date) }}</span>
	            <prismic-rich-text :field="article.data.excerpt"/>
	            <router-link :to="article.type === 'post' ? '/news/' + article.uid : '/magazine/' + article.uid" class="btn"><span><strong>Read More</strong></span></router-link>
	        </div>
	    </aside>
  </article>
  
</template>

<script>
import moment from 'moment'

export default {
  name: 'ArticleItem',
  props: ['article'],
  data () {
    return {
    }
  },
	methods: {
		labelFormat(date) {
			var label = moment(date);
			label = label.format('ddd MMM D');
			return label;
		},
		timeFormat(datetime) {
			var label = moment(datetime);
			label = label.format('H:mma');
			return label;
		}
	},
	created () {
		
  },
  mounted () {
	//   console.log(this.article);
  }
}
</script>